module.exports = __webpack_public_path__ + "static/media/shopify_img-2.0aa04efb.png";